import Feedback from '@/components/Feedback/Feedback';
import IntroVideo from '@/components/Videos/IntroVideo/IntroVideo';
import useCalendar from '@/hooks/calendar/useCalendar';
import { useMemo } from 'react';
import CollectionCompleteVideo from '../Videos/CollectionCompleteVideo/CollectionCompleteVideo';
import MonthOverview from './MonthOverview';

const Calendar = () => {
	const { monthlyCalendar: monthlyCalendarUnfiltered } = useCalendar();

	const allMonths = useMemo(
		() =>
			monthlyCalendarUnfiltered?.filter(
				(month) => month.entries.length > 0,
			),
		[monthlyCalendarUnfiltered],
	);

	const monthIndexToShowFeedbackForm = useMemo(() => {
		if (!allMonths) return 0;
		// Return a random index, but not the first or last one
		return Math.floor(Math.random() * (allMonths.length - 2) + 1);
	}, [allMonths]);

	if (!allMonths) return null;

	return (
		<div className="pt-8">
			<div className="grid gap-8">
				<IntroVideo />
				<CollectionCompleteVideo />
			</div>
			<main className="min-h-screen animate-fade-in transition-all duration-500">
				<ol aria-label="Maanden">
					{allMonths.map((month, index) => (
						<li key={`${month.displayName}-${month.year}`}>
							<MonthOverview month={month} />
							{index === monthIndexToShowFeedbackForm && (
								<Feedback />
							)}
						</li>
					))}
				</ol>
			</main>
		</div>
	);
};

export default Calendar;
